/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 15/2/2023
 */

import WheelSegmentItem from "@shared/WheelModel/WheelSegmentItem";
import {Type} from "@qwoach/class-transformer-wrapper";
import BaseIdObject from "@shared/BaseIdObject";

export default class WheelSingleResponse extends BaseIdObject {

	@Type(() => WheelSegmentItem)
	segments: WheelSegmentItem[] = []
	segmentsFuture: WheelSegmentItem[] = []
	createdAt: number = null


	constructor(segments) {
		super();
		this.segments = segments || []
		this.createdAt = new Date().getTime()
	}
}
